import VBCWebSDK, { sendCustomEvent } from "@/vbc-sdk.js";
import { getAccountDetails } from "../api/global";

export default {
  init: async ({ commit, dispatch }) => {
    try {
      commit("SET_CREDENTIALS", { credentials: window.credentials });
      const accountDetailsResponse = await getAccountDetails(window.credentials);
      commit("SET_ACCOUNT_DETAILS", {
        accountDetails: accountDetailsResponse.data,
      });
      await dispatch("smsRegistrations/loadCatalog");
      const sdk = VBCWebSDK();
      const readyPromise = sdk.ready();
      await readyPromise;
    } catch (error) {
      console.error('[store/init] ERROR during initialization:', error);
      console.error('[store/init] Error stack:', error.stack);
      try {
        const sdk = VBCWebSDK();
        await sdk.ready();
      } catch (readyError) {
        console.error('[store/init] Error calling VBCWebSDK().ready():', readyError);
      }
    }
  },

  sendAmplitudeEvent: async (_, { eventName, eventProperties }) => {
    await sendCustomEvent("amplitudeEvent", {
      eventName,
      eventProperties,
    });
  },
};
